module.exports = __webpack_public_path__ + "img/ticket-sucursal.292ef32e.jpg";